function PasswordRequirements() {
  return (
    <ul className="password-requirements">
      <li>At least one lowercase letter</li>
      <li>At least one uppercase letter</li>
      <li>At least one digit</li>
      <li>At least one special character</li>
    </ul>
  );
}

export default PasswordRequirements;
